import serviceAccounts from '@/apis/coreIAM/serviceAccounts'
import { serviceAccountsTypes } from '@/store/mutationTypes'

export default {
    state: {
        fetchAllServiceAccountRoles: {
            pending: false,
            error: null,
        },
        fetchAllServiceAccountAvailableRoles: {
            pending: false,
            error: null,
        },
        addServiceAccountRoles: {
            pending: false,
            error: null,
        },
        removeServiceAccountRoles: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_ROLES_REQUEST]: function (state) {
            state.fetchAllServiceAccountRoles.pending = true;
        },
        [serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_ROLES_SUCCESS]: function (state) {
            state.fetchAllServiceAccountRoles.error = null;
            state.fetchAllServiceAccountRoles.pending = false;
        },
        [serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_ROLES_FAILURE]: function (state, error) {
            state.fetchAllServiceAccountRoles.error = error;
            state.fetchAllServiceAccountRoles.pending = false;
        },
        [serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_REQUEST]: function (state) {
            state.fetchAllServiceAccountAvailableRoles.pending = true;
        },
        [serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_SUCCESS]: function (state) {
            state.fetchAllServiceAccountAvailableRoles.error = null;
            state.fetchAllServiceAccountAvailableRoles.pending = false;
        },
        [serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_FAILURE]: function (state, error) {
            state.fetchAllServiceAccountAvailableRoles.error = error;
            state.fetchAllServiceAccountAvailableRoles.pending = false;
        },
        [serviceAccountsTypes.ADD_ROLES_TO_SERVICE_ACCOUNT_REQUEST]: function (state) {
            state.addServiceAccountRoles.pending = true;
        },
        [serviceAccountsTypes.ADD_ROLES_TO_SERVICE_ACCOUNT_SUCCESS]: function (state) {
            state.addServiceAccountRoles.error = null;
            state.addServiceAccountRoles.pending = false;
        },
        [serviceAccountsTypes.ADD_ROLES_TO_SERVICE_ACCOUNT_FAILURE]: function (state, error) {
            state.addServiceAccountRoles.error = error
            state.addServiceAccountRoles.pending = false;
        },
        [serviceAccountsTypes.REMOVE_ROLES_FROM_SERVICE_ACCOUNT_REQUEST]: function (state) {
            state.removeServiceAccountRoles.pending = true;
        },
        [serviceAccountsTypes.REMOVE_ROLES_FROM_SERVICE_ACCOUNT_SUCCESS]: function (state) {
            state.removeServiceAccountRoles.error = null;
            state.removeServiceAccountRoles.pending = false;
        },
        [serviceAccountsTypes.REMOVE_ROLES_FROM_SERVICE_ACCOUNT_FAILURE]: function (state, error) {
            state.removeServiceAccountRoles.error = error
            state.removeServiceAccountRoles.pending = false;
        },
    },
    actions: {
        async fetchAllServiceAccountRoles({ commit }, payload) {
            commit(serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_ROLES_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .listServiceAccountRoles(payload.uuid)
                    .then((roles) => {
                        commit(serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_ROLES_SUCCESS, roles.data)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_ROLES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchAllServiceAccountAvailableRoles({ commit }, payload) {
            commit(serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_ROLES_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .listServiceAccountAvailableRoles(payload.uuid)
                    .then((roles) => {
                        commit(serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_ROLES_SUCCESS, roles.data)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.FETCH_ALL_SERVICE_ACCOUNT_ROLES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addServiceAccountRoles({ commit }, payload) {
            commit(serviceAccountsTypes.ADD_ROLES_TO_SERVICE_ACCOUNT_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .addServiceAccountRoles(
                        payload.uuid,
                        payload.roles,
                    )
                    .then(() => {
                        commit(serviceAccountsTypes.ADD_ROLES_TO_SERVICE_ACCOUNT_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.ADD_ROLES_TO_SERVICE_ACCOUNT_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async removeServiceAccountRoles({ commit }, payload) {
            commit(serviceAccountsTypes.REMOVE_ROLES_FROM_SERVICE_ACCOUNT_REQUEST)
            return new Promise((resolve, reject) => {
                serviceAccounts
                    .removeServiceAccountRoles(
                        payload.uuid,
                        payload.roles,
                    )
                    .then(() => {
                        commit(serviceAccountsTypes.REMOVE_ROLES_FROM_SERVICE_ACCOUNT_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(serviceAccountsTypes.REMOVE_ROLES_FROM_SERVICE_ACCOUNT_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}